
const validateCountryIsoCode = countryIsoCode => {
  const regex = /^[a-zA-Z]{2}$/;
  return regex.test(countryIsoCode);
}

export default validateCountryIsoCode;
